module.exports = __webpack_public_path__ + "static/media/instacart-logo.8f7344bc.svg";